<!--免责声明-->
<template>
  <div v-if="spuInfo.disclaimer || spuInfo.concernContent">
    <div
      ref="content"
      id="res"
      :class="[showTotal ? 'all-state' : 'detail-state', 'state']"
      v-if="spuInfo.disclaimer"
      v-track="trackData.introduction({ sku_id: skuId, details_content: 4 })"
    >
      <div v-html="disclaimer" class="mypre"></div>
      <div class="shad" v-if="!exchangeButton && showExchangeButton"></div>
    </div>
    <div
      class="bottom"
      v-if="showExchangeButton"
      v-track="trackData.introduction({ sku_id: skuId, details_content: 4 })"
    >
      <div id="btn" class="button" @click="toogle">
        <span class="word" v-if="exchangeButton">收起</span>
        <span class="word" v-else>展开</span>
        <v-icon name="arrow-right-v3" :class="[!exchangeButton ? 'shou-qi' : 'zhan-kai']"></v-icon>
      </div>
    </div>
    <div
      class="wechat-area state"
      v-if="spuInfo.concernContent"
      v-track="trackData.introduction({ sku_id: skuId, details_content: 5 })"
    >
      <div v-html="concernContent" class="mypre" v-lazy-container="{ selector: 'img' }"></div>
    </div>
  </div>
</template>

<script>
// 第三方包
import { mapState } from 'vuex'
import env from '@/utils/clientEnv'
import { app } from '@/utils'
import { convertHTML } from '@/utils/common'
// 方法
import trackData from '../trackData'

export default {
  name: 'ResponState',
  data() {
    return {
      env,
      // 显示展开还是收起
      exchangeButton: false,
      // 是否显示展开收起按钮
      showExchangeButton: false,
      // 是否展示所有文本内容
      showTotal: true,
      trackData,
      // 官网App顶部高度
      // appHeaderHeight: 0,
      backNum: 0,
      isVivoDarkMode: window.isVivoDarkMode // 是否深色模式
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo']),
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuId
    },
    disclaimer() {
      var str = this.spuInfo.disclaimer.replace(/&lt;br\/&gt;/g, '<br/>')
      return str
    },
    concernContent() {
      var xm = this.spuInfo.concernContent.replace(/&lt;br\/&gt;/g, '<br/>')
      return convertHTML(xm)
    }
  },
  mounted() {
    let height = this.$refs?.content?.offsetHeight
    if (height > 202) {
      this.showTotal = false
      this.showExchangeButton = true
    } else {
      this.showTotal = true
      this.showExchangeButton = false
    }
    // this.navBarHeight()
  },
  methods: {
    /**
     * 获取app顶部导航高度
     */
    navBarHeight() {
      if (this.env.isDefaultHideTitle) {
        return
      }
      let self = this
      // 官网app状态栏高度px
      app.getTitleBarHeight({
        type: 'navBarHeight',
        success: function (val) {
          self.appHeaderHeight = ((val * window.screen.width) / (100 * 720)) * 108
        }
      })
    },
    toogle() {
      if (this.exchangeButton) {
        var topNum = document.documentElement.scrollTop || document.body.scrollTop
        var s = topNum - (document.getElementById('btn').offsetTop - this.backNum)
        // 不用scrollY方法，此方法会增加过渡效果，有兼容性问题，而且此位置不要过渡更好
        window.scrollTo(0, s)
        this.showTotal = !this.showTotal
        this.exchangeButton = !this.exchangeButton
      } else {
        this.backNum = document.getElementById('btn').offsetTop
        this.showTotal = !this.showTotal
        this.exchangeButton = !this.exchangeButton
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./respon-state.scss" />
<style lang="scss">
.wechat-area img {
  width: 100% !important;
}
</style>
